import getActions from '../../shared/store/actionsFactory';
import { adminPageNames, adminPageTitles } from '../../shared/adminPageNames';
import getApi from '../../shared/apiFactory';

import Config from '../../../config';
import agGridConfig from '../../../agGridConfig';

import {
  FETCH_INITIAL_DATA_FOR_LEGAL_ENTITY_MODAL,
  FETCH_INITIAL_DATA_FOR_LEGAL_ENTITY_MODAL_SUCCESS,
  FETCH_INITIAL_DATA_FOR_LEGAL_ENTITY_MODAL_FAILURE,
} from './types';
import {
  fetchEnabledFlagValues as fetchEnabledFlagValuesApi,
  fetchUsTaxTypes as fetchUsTaxTypesApi,
  fetchLocalTaxTypes as fetchLocalTaxTypesApi,
  fetchCountries as fetchCountriesApi,
  fetchLegalEntities as fetchLegalEntitiesApi,
} from '../api';
import { fetchingError } from '../../../shared/store/actions';
import { errorNotification } from '../../../shared/store/notificationActions';

import fixDataTypes from '../xlsxImport/processors/fixDataTypes.processor';
import { FIELD_MAPPINGS, MIN_COLUMNS_NUMBER, MAX_COLUMNS_NUMBER } from '../xlsxImport/constants';
import { columnHeaders } from '../columnHeaders';
import { COMPANY_SOURCES } from '../../../shared/constants';

export const sharedActions = getActions(adminPageNames.LEGAL_ENTITIES, {
  pageTitle: adminPageTitles.LEGAL_ENTITIES,
  api: getApi({
    pageTitle: adminPageTitles.LEGAL_ENTITIES,
    endpoints: {
      FETCH: Config.endpoints.FETCH_LEGAL_ENTITIES,
      INSERT: Config.endpoints.ADD_LEGAL_ENTITY,
      UPDATE: Config.endpoints.UPDATE_LEGAL_ENTITY,
      VALIDATE: Config.endpoints.VALIDATE_LEGAL_ENTITY,
      IMPORT: Config.endpoints.SAVE_LEGAL_ENTITIES,
    },
  }),
  sortingField: 'legalEntity',
  agGridConfig: agGridConfig.adminLegalEntities,
  excel: {
    sheetName: 'Legal Entities',
    lastColumnLetter: 'AG',
    dataTypesProcessor: fixDataTypes,
    columnHeaders,
    fieldMappings: FIELD_MAPPINGS,
    minColumnsNumber: MIN_COLUMNS_NUMBER,
    maxColumnsNumber: MAX_COLUMNS_NUMBER,
  },
});

export const fetchInitialDataForLegalEntityModal = period => async dispatch => {
  dispatch({ type: FETCH_INITIAL_DATA_FOR_LEGAL_ENTITY_MODAL });
  try {
    const [
      enabledFlagValues,
      usTaxTypeValues,
      localTaxTypeValues,
      countryCodeValues,
      legalEntities,
    ] = await Promise.all([
      fetchEnabledFlagValuesApi(),
      fetchUsTaxTypesApi(),
      fetchLocalTaxTypesApi(),
      fetchCountriesApi(),
      fetchLegalEntitiesApi({ periodName: period.name }),
    ]);

    return dispatch({
      type: FETCH_INITIAL_DATA_FOR_LEGAL_ENTITY_MODAL_SUCCESS,
      enabledFlagValues,
      usTaxTypeValues,
      localTaxTypeValues,
      countryCodeValues,
      sourceOptions: [{ label: COMPANY_SOURCES.GLDRPT, value: COMPANY_SOURCES.GLDRPT },
        { label: COMPANY_SOURCES.TLS, value: COMPANY_SOURCES.TLS }],
      legalEntities,
    });
  } catch (error) {
    dispatch({ type: FETCH_INITIAL_DATA_FOR_LEGAL_ENTITY_MODAL_FAILURE });
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};
